import CONF from 'config/conf.singleton';
import H from 'constants/httpMethod.const';
import { NO_MEDIA_TYPE } from 'constants/misc.const';
import { AUTH_API } from 'middleware/api';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';
import { isNotValidId } from 'utils/predicates/fields.util';

// Action types
export const PATCH_CLIENT_PICTURE_REQUEST = 'PATCH_CLIENT_PICTURE_REQUEST';
export const PATCH_CLIENT_PICTURE_SUCCESS = 'PATCH_CLIENT_PICTURE_SUCCESS';
export const PATCH_CLIENT_PICTURE_FAILURE = 'PATCH_CLIENT_PICTURE_FAILURE';

/**
 * Redux thunk action to patch client profile picture using multipart form data.
 * @param {object} options - { clientId, profile_image (File | null) }
 */
export const bePatchClientPicture = (options) => {
  const clientId = isNotValidId(options?.clientId) ? `invalid-client-id-${String(options?.clientId)}` : options?.clientId;

  const body = new FormData();

  if (options?.profile_image instanceof File) {
    body.append('profile_image', options?.profile_image);
  } else if (options?.profile_image === null) {
    // empty field for removing image
    body.append('profile_image', '');
  }

  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      authenticated: true,
      config: { method: H.patch, body, headers: { 'Content-Type': NO_MEDIA_TYPE } },
      endpoint: `salon/v3/:salonId/client/picture/${clientId}/`,
      types: [PATCH_CLIENT_PICTURE_REQUEST, PATCH_CLIENT_PICTURE_SUCCESS, PATCH_CLIENT_PICTURE_FAILURE],
    },
  };
};

const fromDtoToClientPicture = (dto) => ({
  profileImage: dto?.results?.profile_image,
});

const fromClientPictureToDto = (item) => ({
  profile_image: item?.profileImage,
});

export const ibeClientPictureRead = actionEndpointBe('ibeClientPictureRead', H.get, 'salon/v3/:salonId/client/picture/:clientId/', (options, extra) => ({
  ...options,
  inert: true,
  isMissingParams: !extra?.enabled,
  params: { clientId: fromAnyToTrimmed(extra?.clientId) || 0 },
  fromDto: fromDtoToClientPicture,
}));

export const ibeClientPictureWrite = actionEndpointBe('ibeClientPictureWrite', H.patch, 'salon/v3/:salonId/client/picture/:clientId/', (options, extra) => ({
  ...options,
  inert: true,
  fromDto: fromDtoToClientPicture,
  toDto: fromClientPictureToDto,
  data: extra?.data,
  params: { clientId: fromAnyToTrimmed(extra?.clientId) || 0 },
}));
